import React, { Component, useState, useEffect } from "react";
import { Link, useLocation, useSearchParams } from "react-router-dom";

// Material UI Components
import Box from "@mui/material/Box";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";

import "../style/filterstrip.css";
function Filterstrip(props) {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const value =
    queryParams.get("keyword") ||
    queryParams.get("search") ||
    queryParams.get("collect");

  const [searchParams, setSearchParams] = useSearchParams();
  const [isChecked, setIsChecked] = useState(false);

  const handleChange = (event) => {
    // Toggle the checkbox state
    const newIsChecked = !isChecked;
    setIsChecked(newIsChecked); // Update checkbox state

    // Update the search parameters based on the checkbox state
    if (newIsChecked) {
      // If the checkbox is now checked, add the new sort-by value
      searchParams.set("sort-by", event.target.value);
    } else {
      // If the checkbox is now unchecked, remove the sort-by parameter
      searchParams.delete("sort-by");
    }

    // Update the URL
    setSearchParams(searchParams);
    props.setParams({ sortBy: event.target.value });
  };
  return (
    <div className="Filterstrip">
      <Box sx={{ maxWidth: 500 }}>
        <p style={{ textAlign: "left" }}>
          <b style={{ fontSize: "1.8rem" }}>{value}</b>
          <br />
          <i>{props.productCount} products</i>
        </p>
      </Box>

      <Box>
        <FormControl sx={{ minWidth: 120 }} fullWidth>
          <InputLabel id="demo-simple-select-label">Sort by</InputLabel>
          <Select
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            label="Sort by"
            onChange={handleChange}
          >
            <MenuItem value={"asc"}>Price Low to High</MenuItem>
            <MenuItem value={"desc"}>Price High to Low</MenuItem>
          </Select>
        </FormControl>
      </Box>
    </div>
  );
}

export default Filterstrip;
